export default __webpack_public_path__ + "static/media/real-time-tracking-2.90d8d3d7.jpeg";